/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import {
  Button,
  Dropdown,
  Menu,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';

export default class PageNav extends Component {
  static propTypes = {
    upward: PropTypes.bool,
    color: PropTypes.string,
    currentPage: PropTypes.number,
    loading: PropTypes.bool,
    hasLess: PropTypes.bool,
    hasMore: PropTypes.bool,
    hideDropdown: PropTypes.bool,
    count: PropTypes.number,
    limit: PropTypes.number,
    offset: PropTypes.number,
    dataSize: PropTypes.number,
    onChange: PropTypes.func,
    size: PropTypes.string,
    floated: PropTypes.string,
    attached: PropTypes.string,
    noScrollTop: PropTypes.bool,
    // Cursor pagination toggle
    isCursorPagination: PropTypes.bool,
    // Current "next" cursor (from latest API response)
    nextCursor: PropTypes.shape({
      pit_id: PropTypes.string,
      search_after: PropTypes.string,
    }),
    // Stack of previous cursors (for "Prev" button)
    cursorStack: PropTypes.arrayOf(
      PropTypes.shape({
        pit_id: PropTypes.string,
        search_after: PropTypes.string,
      }),
    ),
  }
  static defaultProps = {
    currentPage: 1,
    loading: false,
    hideDropdown: false,
    count: 0,
    limit: 0,
    offset: 0,
    dataSize: 0,
    size: 'tiny',
    noScrollTop: false,
    isCursorPagination: false,
    nextCursor: null,
    cursorStack: [], // previous cursors
  }
  constructor(props) {
    super(props);
    const currentPage = props.currentPage || 1;
    this.state = {
      currentPage,
    };
  }
  componentWillReceiveProps(nextProps) {
    const currentPage = nextProps.currentPage || this.state.currentPage;
    this.setState({
      currentPage,
    });
  }
  getHasMore = () => {
    const { count, limit, offset, dataSize, hasMore, isCursorPagination, nextCursor } = this.props;

    if (isCursorPagination) {
      return !!(nextCursor && nextCursor.search_after);
    }
    if (hasMore !== undefined) {
      return hasMore;
    }
    if (dataSize === limit) {
      return dataSize + offset !== count;
    }
    return false;
  }
  getHasLess = () => {
    const { offset, hasLess, isCursorPagination, cursorStack } = this.props;

    if (isCursorPagination) {
      return (cursorStack || []).length > 0;
    }
    if (hasLess !== undefined) {
      return hasLess;
    }
    return offset !== 0;
  }
  getPageCount = () => {
    const { count, limit } = this.props;
    let totalPage = 1;
    if (count > 0 && limit > 0) {
      totalPage = Math.ceil(count / limit);
    }
    const pageOptions = [];
    for (let i = 1; i <= totalPage; i += 1) {
      pageOptions.push({
        text: i,
        value: i,
      });
    }
    return pageOptions;
  }
  handleChangePage = (direction) => {
    const { isCursorPagination, onChange, cursorStack, nextCursor } = this.props;

    if (isCursorPagination) {
      if (!onChange) return;

      if (direction === 'next') {
        onChange({
          type: 'next',
          cursor: nextCursor,
        });
      }

      if (direction === 'prev') {
        const stack = cursorStack || [];
        const prevCursor = stack[stack.length - 1];

        onChange({
          type: 'prev',
          cursor: prevCursor || null,
        });
      }

      return;
    }

    // Offset pagination mode (original logic)
    const currentPage = this.state.currentPage + direction;
    this.handleOnChange(currentPage);
  };
  handleInputPage = (e, { value }) => {
    const currentPage = value;
    this.handleOnChange(currentPage);
  }
  handleOnChange(currentPage) {
    if (this.props.onChange) {
      this.props.onChange(currentPage);
    }
    this.setState({ currentPage }, () => {
      if (!this.props.noScrollTop) {
        window.scrollTo(0, 0);
      }
    });
  }
  render() {
    const { size, loading } = this.props;
    const options = this.getPageCount();
    const hasMore = this.getHasMore();
    const hasLess = this.getHasLess();
    return (
      <Menu
        pagination
        size={size}
        floated={this.props.floated}
        attached={this.props.attached}
        style={this.props.color ? { background: this.props.color } : null}
      >
        <Menu.Item
          as={Button}
          size={size}
          onClick={() => this.handleChangePage(this.props.isCursorPagination ? 'prev' : -1)}
          disabled={!hasLess || loading}
          icon="left chevron"
        />
        {
          this.props.hideDropdown ?
            null :
            this.props.isCursorPagination ? (
              <Menu.Item disabled style={{ minWidth: '3rem', justifyContent: 'center' }}>
                {this.state.currentPage}
              </Menu.Item>
            ) : (
              <Dropdown
                upward={this.props.upward}
                item
                scrolling
                search
                selectOnBlur={false}
                options={options}
                onChange={this.handleInputPage}
                value={this.state.currentPage}
                disabled={options.length === 1 || loading}
              />
            )
        }
        <Menu.Item
          as={Button}
          size={size}
          onClick={() => this.handleChangePage(this.props.isCursorPagination ? 'next' : 1)}
          disabled={!hasMore || loading}
          icon="right chevron"
        />
      </Menu>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PageNav.jsx